import React, { Component } from 'react';
import { Layout, Card } from 'antd';
import { Footer } from '../../common/footer/footer';
import { graphql } from 'react-apollo';
import ResetPasswordRequestForm from "./form";
import { getCurrentUser } from '../../authorization/queries/getCurrentUser';
import Spinner from '../../spinner/spinner';
import { SiteLogo } from '../../common/siteLogo/siteLogo'
import './reset_password_request.css';

const { Content } = Layout;

class ResetPasswordRequestPage extends Component {
  get redirectPathMapping() {
    return {
      'Administrator': '/admin/dashboard',
      'Evangelist': '/evangelist/dashboard',
      'SeniorPastor': '/pastor/dashboard',
      'Pastor': '/pastor/dashboard',
    }
  }

  redirect = (currentUser) => {
    this.props.history.replace(this.redirectPathMapping[currentUser.type]);
  };

  componentWillMount() {
    if(this.props.data.current_user) {
      this.redirect(this.props.data.current_user);
    }
  }

  componentWillUpdate() {
    if(this.props.data.current_user) {
      this.redirect(this.props.data.current_user);
    }
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner />
    } else {
      return (
        <Layout className="troubles-logging-in-page troubles-logging-in-page__layout">
          <Content className="troubles-logging-in-page__content">
            <SiteLogo/>
            <Card className="troubles-logging-in-page__content-card">
              <ResetPasswordRequestForm token={this.props.token} />
            </Card>
          </Content>
          <Footer className="footer-transparent"/>
        </Layout>
      );
    }
  }
}

export default graphql(getCurrentUser)(ResetPasswordRequestPage);



// WEBPACK FOOTER //
// ./src/components/pages/reset_password_request/reset_password_request.js